/* ==========================================================
   SEVUN – Landing Page JS
   Scope: #sevun-landing
   ========================================================== */

document.addEventListener('DOMContentLoaded', () => {

  /* ----------------------------------------------------------
     GALLERY / LIGHTBOX
  ---------------------------------------------------------- */

  const imagePaths = [
    'galerie/galerie_1.jpg', 'galerie/galerie_2.jpg', 'galerie/galerie_3.jpg',
    'galerie/galerie_4.jpg', 'galerie/galerie_5.jpg', 'galerie/galerie_6.jpg',
    'galerie/galerie_7.jpg', 'galerie/galerie_8.jpg', 'galerie/galerie_9.jpg',
    'galerie/galerie_10.jpg', 'galerie/galerie_11.jpg', 'galerie/galerie_12.jpg',
    'galerie/galerie_13.jpg', 'galerie/galerie_14.jpg', 'galerie/galerie_15.jpg'
  ];

  let currentImageIndex = 0;

  const modal = document.getElementById('image-modal');
  const modalImage = document.getElementById('modal-image');

  if (modal && modalImage) {

    window.openModal = function (src, index) {
      currentImageIndex = index;
      modalImage.src = src;
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    };

    window.closeModal = function () {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
    };

    window.prevImage = function () {
      currentImageIndex =
        currentImageIndex === 0 ? imagePaths.length - 1 : currentImageIndex - 1;
      modalImage.src = imagePaths[currentImageIndex];
    };

    window.nextImage = function () {
      currentImageIndex =
        currentImageIndex === imagePaths.length - 1 ? 0 : currentImageIndex + 1;
      modalImage.src = imagePaths[currentImageIndex];
    };

    document.addEventListener('keydown', (e) => {
      if (modal.classList.contains('hidden')) return;

      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'ArrowRight') nextImage();
    });
  }

  /* ----------------------------------------------------------
     LANGUAGE SWITCH
  ---------------------------------------------------------- */

  const langButtons = document.querySelectorAll('[data-lang-key]');
  const translatables = document.querySelectorAll('[data-lang-fr], [data-lang-en]');

  let currentLang = 'fr';
  try {
    currentLang = localStorage.getItem('sevunLang') || 'fr';
  } catch (e) {}

  function updateLanguage(lang) {
    document.documentElement.lang = lang;

    langButtons.forEach(btn => {
      btn.classList.toggle('border-primary', btn.dataset.langKey === lang);
      btn.classList.toggle('text-primary', btn.dataset.langKey === lang);
      btn.classList.toggle('text-gray-600', btn.dataset.langKey !== lang);
    });

    translatables.forEach(el => {
      const text = el.getAttribute(`data-lang-${lang}`);
      if (text) el.innerHTML = text;
    });

    const title = document.querySelector('title');
    if (title) {
      const t = title.getAttribute(`data-lang-${lang}`);
      if (t) document.title = t;
    }

    try {
      localStorage.setItem('sevunLang', lang);
    } catch (e) {}
  }

  langButtons.forEach(btn => {
    btn.addEventListener('click', () => updateLanguage(btn.dataset.langKey));
  });

  updateLanguage(currentLang);

  /* ----------------------------------------------------------
     LUCIDE ICONS
  ---------------------------------------------------------- */

  if (window.lucide) {
    lucide.createIcons();
  }

});
